/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underscore (_)`)
};

const es_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guión bajo (_)`)
};

const de_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstrich (_)`)
};

const nl_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderstrepingsteken (_)`)
};

const fr_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiret bas (_)`)
};

const it_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattino basso (_)`)
};

const pt_br2_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhado (_)`)
};

const pt_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhado (_)`)
};

const ja_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンダースコア (_)`)
};

const zh_sg_sep_underscore = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下划线 (_)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_sep_underscore = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_sep_underscore(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_sep_underscore", locale)
	if (locale === "en") return en_sg_sep_underscore(inputs)
	if (locale === "es") return es_sg_sep_underscore(inputs)
	if (locale === "de") return de_sg_sep_underscore(inputs)
	if (locale === "nl") return nl_sg_sep_underscore(inputs)
	if (locale === "fr") return fr_sg_sep_underscore(inputs)
	if (locale === "it") return it_sg_sep_underscore(inputs)
	if (locale === "pt-BR") return pt_br2_sg_sep_underscore(inputs)
	if (locale === "pt") return pt_sg_sep_underscore(inputs)
	if (locale === "ja") return ja_sg_sep_underscore(inputs)
	return zh_sg_sep_underscore(inputs)
};